import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import QuoteForm from "@/components/QuoteForm";

interface QuoteModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** The Get Free Quote dialog every page opens: its heading and the form. */
const QuoteModal = ({ open, onOpenChange }: QuoteModalProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      className="grid-cols-[minmax(0,1fr)] sm:max-w-xl md:max-w-3xl max-h-[90vh] overflow-y-auto overflow-x-hidden rounded-2xl border-none bg-[#FDFCF7] p-5 shadow-2xl sm:p-7 [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:bg-[#EDE8D0] [&::-webkit-scrollbar-thumb]:bg-primary [&::-webkit-scrollbar-thumb]:rounded-full cursor-default"
      onOpenAutoFocus={(e) => {
        e.preventDefault();
      }}
    >
      <DialogHeader className="text-center sm:text-center">
        <DialogTitle className="text-2xl font-bold text-primary font-poppins">
          Get Free Quote
        </DialogTitle>
        <p className="text-sm text-muted-foreground">
          Find the right Ayurvedic center for your healing journey
        </p>
      </DialogHeader>
      <QuoteForm twoColumns onSent={() => onOpenChange(false)} />
    </DialogContent>
  </Dialog>
);

export default QuoteModal;
